import { Component } from '@angular/core';
import { ApiService } from 'app/api.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';

declare const Mangler: any;

@Component({
	selector: 'modal-select-snag',
	templateUrl: './modal-select-snag.component.html'
})
export class ModalSelectSnagComponent extends UIModalBaseComponent {

	projectId;
	list: any[] = [];
	search = '';
	multiSelectList = [];
	typeMap = {
		comment: 'Comment',
		image: 'Image',
		material_list: 'Material List',
		expense: 'Expense'
	};

	constructor(
		private api: ApiService,
	) {
		super();
	}

	open(mdata: any) {
		this.projectId = mdata.project_id;
		this.multiSelectList = [];
		this.list = null;
		this.api.project.listSnags(this.projectId, data => {
			this.list = Mangler.filter(data, { is_quoted: 0 });
		});

		this.modal.open();
	}

	selectItem(item) {
		const found = Mangler.findOne(this.multiSelectList, { id: item.id });
		if (found) {
			const i = this.multiSelectList.indexOf(found);
			if (i !== -1) this.multiSelectList.splice(i, 1);
		} else {
			this.multiSelectList.push(item);
		}
		this.multiSelectList = this.multiSelectList.slice();
	}

	addSnaggsButton() {
		if (this.multiSelectList.length) {
			this.modal.close(this.multiSelectList);
		}
	}
	
	isItemSelected(item) {
		return !!Mangler.findOne(this.multiSelectList, { id: item.id });
	}
}
